/**
 * @class GridDimension
 */
export default class GridDistance {
    /**
     * @param {number} rows
     * @param {number} columns
     * @constructor
     */
    constructor(rows, columns) {
        this.rows = parseInt(rows, 10);
        this.columns = parseInt(columns, 10);
    }

    /**
     * @return {number}
     */
    getRows() {
        return this.rows;
    }

    /**
     * @return {number}
     */
    getColumns() {
        return this.columns;
    }
}
